import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../store';
import SliderListItem from '../../../../../list-items/SliderListItem';
import CondensedListItem from '../../../../../list-items/CondensedListItem';
import { previewHistoryBatch } from '../../../store/extensions';
import { getMaxPositionForAspectRatio } from '../../VideoElementsEditor/ImageElements/imageElementSizeCalculations';

const TextPositionListItem = (props) => {
    const { textElementPositionX, textElementPositionY, index, updateTextElement, maxXPosition, maxYPosition } = props;

    const onPositionXChange = (value) => {
        previewHistoryBatch.start();

        updateTextElement(index, {
            position: { x: value }
        });
    };

    const onPositionYChange = (value) => {
        previewHistoryBatch.start();

        updateTextElement(index, {
            position: { y: value }
        })
    };
    
    return (
        <CondensedListItem 
            elements={[
                {
                    width: 6,
                    component: <SliderListItem
                        title='X Position'
                        value={textElementPositionX}
                        displayMultiplier={1}
                        min={-maxXPosition}
                        max={maxXPosition}
                        step={1}
                        onValueChange={onPositionXChange}
                        onSliderChangeCommitted={() => previewHistoryBatch.end()}
                        onInputFocusIn={() => previewHistoryBatch.start()}
                        onInputFocusOut={() => previewHistoryBatch.end()}
                    />
                },
                {
                    width: 6,
                    component: <SliderListItem
                        title='Y Position'
                        value={textElementPositionY}
                        displayMultiplier={-1}
                        min={-maxYPosition}
                        max={maxYPosition}
                        step={1}
                        onValueChange={onPositionYChange}
                        onSliderChangeCommitted={() => previewHistoryBatch.end()}
                        onInputFocusIn={() => previewHistoryBatch.start()}
                        onInputFocusOut={() => previewHistoryBatch.end()}
                    />
                }
            ]}
        />
    );
};

const mapStateToProps = (state, ownProps) => {
    const { videoSettings } = state.createPreview.present;
    const {
        x: textElementPositionX,
        y: textElementPositionY,
    } = videoSettings.text.textElements[ownProps.index].position;

    // The range has to match the frame on screen, the same one a drag on the canvas is held to. The
    // landscape limits the API serves would let a line in a portrait frame be slid far off the canvas.
    const { maxXPosition, maxYPosition } = getMaxPositionForAspectRatio(videoSettings.aspectRatio);

    return { 
        textElementPositionX,
        textElementPositionY,
        maxXPosition,
        maxYPosition
    };
}

const mapDispatchToProps = (dispatch) => {
    const updateTextElement = (index, properties) => dispatch(createActions.updateTextElement(index, properties));
    return { updateTextElement }
}

export default connect(mapStateToProps, mapDispatchToProps)(TextPositionListItem);